import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericResponse } from 'src/app/model/generic.response';
import { ApiService } from 'src/app/services/api.service';

export interface WalletBalanceSummary {
    availableBalance: number;
    cashbacksAllocated: number;
    pendingCashbackAllocations: number;
    warningThreshold: number;
    cutoffThreshold: number;
}

export interface UpdateWalletThresholdsRequest {
    warningThreshold: number;
    cutoffThreshold: number;
}

export interface WalletTopupResponse {
    notified: number;
    message: number;
    emailSent: boolean;
}


@Injectable({
    providedIn: 'root',
})
export class WalletBalanceSummaryService {
    private readonly endpoint = 'wallet';
    private readonly skipActivityHeaders = new HttpHeaders({
        'X-Skip-Loading': 'true',
    });

    constructor(
        private http: HttpClient,
        private apiService: ApiService,
    ) { }

    getWalletSummary(supplierId?: number): Observable<GenericResponse<WalletBalanceSummary>> {
        const url = this.apiService.getApiEndpoint(
            this.endpoint,
            `supplier/summary`
        );

        return this.http.get<GenericResponse<WalletBalanceSummary>>(url, {
            params: supplierId ? { supplierId } : {},
        });
    }

    updateWalletThresholds(
        supplierId: number | undefined,
        payload: UpdateWalletThresholdsRequest
    ): Observable<GenericResponse<WalletBalanceSummary>> {
        const url = this.apiService.getApiEndpoint(
            this.endpoint,
            `supplier/thresholds`
        );

        return this.http.put<GenericResponse<WalletBalanceSummary>>(url, payload, {
            params: supplierId ? { supplierId } : {},
            headers: this.skipActivityHeaders,
        });
    }

    requestTopup(supplierId?: number): Observable<GenericResponse<WalletTopupResponse>> {
        const url = this.apiService.getApiEndpoint(
            this.endpoint,
            `supplier/topup`
        );

        return this.http.post<GenericResponse<WalletTopupResponse>>(
            url,
            {},
            {
                params: supplierId ? { supplierId } : {},
                headers: this.skipActivityHeaders,
            }
        );
    }
}
